<template>
  <section class="dashboard">
    <div class="proBanner">
      <div>
        <span class="d-flex align-items-center purchase-popup">
          <p>iOS version 3.0.6 release available!</p>
          <a href="https://apps.apple.com/gb/app/trackd-songs-start-here/id1496465739" rel="noopener noreferrer" target="_blank" class="btn btn-sm purchase-button btn-primary ml-auto">Check Latest Version</a>
          <i class="mdi mdi-close bannerClose"  @click="toggleProBanner()" ></i>
        </span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="d-flex flex-row p-3">
              <div class="align-self-top">
                <p class="card-title mb-1 font-weight-bold">Today's sales</p>
                <h3 class="mb-0">£2800</h3>
              </div>
              <div class="align-self-center flex-grow text-right">
                <i class="icon-lg mdi mdi-chart-pie text-primary"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="d-flex flex-row p-3">
              <div class="align-self-top">
                <p class="card-title mb-1 font-weight-bold">Total Revenue</p>
                <h3 class="mb-0">£38,879</h3>
              </div>
              <div class="align-self-center flex-grow text-right">
                <i class="icon-lg mdi mdi-cash-multiple text-warning"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="d-flex flex-row p-3">
              <div class="align-self-top">
                <p class="card-title mb-1 font-weight-bold">Today's Active Visitors</p>
                <h3 class="mb-0">25690</h3>
              </div>
              <div class="align-self-center flex-grow text-right">
                <i class="icon-lg mdi mdi-account-outline text-success"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 grid-margin">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Recent Users</h4>
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th>
                      <div class="form-check m-0">
                        <label class="form-check-label">
                          <input class="checkbox" type="checkbox"><i class="input-helper"></i>
                        </label>
                      </div>
                    </th>
                    <th> Profile </th>
                    <th> Username </th>
                    <th> Email </th>
                    <th> Songs </th>
                    <th> Onboarded Date </th>
                    <th> Actions </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div class="form-check m-0">
                        <label class="form-check-label">
                          <input class="checkbox" type="checkbox"><i class="input-helper"></i>
                        </label>
                      </div>
                    </td>
                    <td>
                      <img src="../../assets/images/faces/face1.jpg" alt="image" />
                    </td>
                    <td> David Grey </td>
                    <td> davidgrey@demo.com </td>
                    <td> 63 </td>
                    <td> 01/11/2020 </td>
                    <td>
                      <i class="mdi mdi-pencil icon-sm mr-2 text-success"></i>
                      <i class="mdi mdi-close icon-sm text-danger"></i>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="form-check m-0">
                        <label class="form-check-label">
                          <input class="checkbox" type="checkbox"><i class="input-helper"></i>
                        </label>
                      </div>
                    </td>
                    <td>
                      <img src="../../assets/images/faces/face2.jpg" alt="image" />
                    </td>
                    <td> Stella Johnson </td>
                    <td> stella@demo.com </td>
                    <td> 12 </td>
                    <td> 03/11/2020 </td>
                    <td>
                      <i class="mdi mdi-pencil icon-sm mr-2 text-success"></i>
                      <i class="mdi mdi-close icon-sm text-danger"></i>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="form-check m-0">
                        <label class="form-check-label">
                          <input class="checkbox" type="checkbox"><i class="input-helper"></i>
                        </label>
                      </div>
                    </td>
                    <td>
                      <img src="../../assets/images/faces/face5.jpg" alt="image" />
                    </td>
                    <td> Marina Michel </td>
                    <td> marinam@demo.com </td>
                    <td> 8 </td>
                    <td> 26/10/2020 </td>
                    <td>
                      <i class="mdi mdi-pencil icon-sm mr-2 text-success"></i>
                      <i class="mdi mdi-close icon-sm text-danger"></i>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="form-check m-0">
                        <label class="form-check-label">
                          <input class="checkbox" type="checkbox"><i class="input-helper"></i>
                        </label>
                      </div>
                    </td>
                    <td>
                      <img src="../../assets/images/faces/face3.jpg" alt="image" />
                    </td>
                    <td> John Doe </td>
                    <td> djohn@demo.com </td>
                    <td> 3 </td>
                    <td> 18/12/2020 </td>
                    <td>
                      <i class="mdi mdi-pencil icon-sm mr-2 text-success"></i>
                      <i class="mdi mdi-close icon-sm text-danger"></i>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="form-check m-0">
                        <label class="form-check-label">
                          <input class="checkbox" type="checkbox"><i class="input-helper"></i>
                        </label>
                      </div>
                    </td>
                    <td>
                      <img src="../../assets/images/faces/face4.jpg" alt="image" />
                    </td>
                    <td> Catherine </td>
                    <td> catherine@demo.com </td>
                    <td> 8 </td>
                    <td> 15/09/2020 </td>
                    <td>
                      <i class="mdi mdi-pencil icon-sm mr-2 text-success"></i>
                      <i class="mdi mdi-close icon-sm text-danger"></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// import RadialProgressBar from 'vue-radial-progress'
// import todoList from '../../components/apps/todoList'

export default {
  name: 'dashboard',
  components: {
    // RadialProgressBar,
    // todoList
  },
  data() {
    return {
      time1: null,
      slide1: 0,
    };
  },
  methods: {
    toggleProBanner: () => {
      document.querySelector('body').classList.toggle('pro-banner-collapse');
    }
  }
}
</script>

<style scoped>

</style>